import { useContext, useRef, useState } from 'react';
import UserContext from '../helpers/UserContext';
import classes from './SignupForm.module.css';
import HTMLSelect from './HTMLSelect';
import zxcvbn from 'zxcvbn';
import qs from 'qs';
import axios from 'axios';
import {URL} from '../helpers/Options';

function SignupForm( props ) {
	const userCtx = useContext(UserContext);
	const inputQty = useRef();
	const inputFirstName = useRef();
    const inputLastName = useRef();
	const inputEmail = useRef();
	const inputEmailConfirmation = useRef();
	const inputPassword = useRef();
	const feedback = useRef();
	const message = useRef();
	const svcHours = useRef();
	const inputPasswordConfirmation = useRef();
	const [passwordFormIsShown, showPasswordForm] = useState(false);
	const [pwStrengthClass, setPasswordStrength] = useState('score0');
	const [submitClass, setSubmitClass] = useState('active');
	const startQty = props.signupQty;

	function submitHandler( event ) {
		event.preventDefault();
		if (submitClass==='active') {
			var thePassword = 'NONE';
			var saveUserFlag = 'false';
			if (typeof inputPassword.current !== 'undefined') { thePassword = inputPassword.current.value; saveUserFlag='true'}
			const theEmail = inputEmail.current.value;
			const theLastName = inputLastName.current.value;
			const theFirstName = inputFirstName.current.value;
			const theFunction = (startQty>0) ? 'changeSignup'  : 'addSignup';
			const theQty = inputQty.current.value;
			var data = {
				action: 	'SAS_handleAJAX',
				function: 	theFunction,
				'createUser': saveUserFlag,
				'password':	thePassword,
				'activity':	props.id,
				'actName':	props.title,
				'deadline':	props.deadline,
				'recordID':	props.signupID,
				'fname':	theFirstName,
				'lname':	theLastName,
				'email':	theEmail,
				'svcHours':	svcHours.current.value,
				'quantity':	theQty
			};
			console.log(data, props);
			
			axios.post(URL, qs.stringify(data)).then(
				function (response) {
					//message.current.innerHTML = response.data;
				}
			);
			
		props.onDone();
		}
    }

	function setPassword() { showPasswordForm(true); setSubmitClass('inactive')}

	function checkPasswordStrength(event) {
		event.preventDefault();
		const thePassword = inputPassword.current.value;
		const thePasswordConfirmation = inputPasswordConfirmation.current.value;
		const testedResult = zxcvbn(thePassword);
		const theWarning = testedResult.feedback.warning;
		var theSuggestions = '';
		if (testedResult.feedback.suggestions.length > 1) {
			theSuggestions = testedResult.feedback.suggestions.join('. ') + '. '; }
		const crackTime = testedResult.crack_times_display.offline_slow_hashing_1e4_per_second;
		const crackMsg = "Can be cracked in " + crackTime + '. ';
		var theScore = testedResult.score;
		var pwWarning = '';
		if (thePassword === thePasswordConfirmation) { pwWarning ='';}
		else {
			pwWarning= 'Passwords do not match';
			theScore = 0;
		}
		feedback.current.innerHTML =  theWarning + theSuggestions + crackMsg + pwWarning;
		setPasswordStrength('score'+testedResult.score);
		if (theScore > 2) { setSubmitClass('active'); }
		else { setSubmitClass('inactive'); }
	}

	function showPassword() {
		const theType = (inputPassword.current.type === 'text') ? 'password' : 'text';
		inputPassword.current.type = theType;
		inputPasswordConfirmation.current.type = theType;
	}

	var defaultFirstName = '';
	var defaultLastName = '';
	var defaultEmail = '';
	if (typeof userCtx.user.email !== 'undefined' && userCtx.user.email !== 'NONE') {
		defaultFirstName = userCtx.user.firstName;
		defaultLastName = userCtx.user.lastName;
		defaultEmail = userCtx.user.email;
	}

	return(
		<div className={classes.signupForm}>
			{props.signupQty>0 && <h1>Updating Signup for {props.title}</h1>}
			{props.signupQty===0 && <h1>Signing up for {props.title}</h1>}
			<form onSubmit={submitHandler}>
				<label htmlFor="firstname">First Name:</label>
				<input id="firstname" type="text" defaultValue={defaultFirstName} ref={inputFirstName}/>
				<label htmlFor="lastname">Last Name:</label>
				<input id="lastname" type="text" defaultValue={defaultLastName} ref={inputLastName}/>
				<label htmlFor="email">Email:</label>
				<input id="email" type="email" defaultValue={defaultEmail} ref={inputEmail}/>
				<label htmlFor="emailConfirmation">Confirm Email:</label>
				<input id="emailConfirmation" type="email"  defaultValue={defaultEmail} ref={inputEmailConfirmation}/>
				<label >Quantity:</label>
				<HTMLSelect 
					id={props.id} 
					limit={props.limit} 
					signupQty={props.signupQty} 
					onChange='updateQty' 
					ref={inputQty}
				/><br />
				<input 
					type="checkbox" 
					id="serviceFlag" 
					value="yes" 
					className={classes.inputCheck}
					ref={svcHours}
				/>
				<label htmlFor="serviceFlag">I'd like service hours</label>
				<br />
				{!passwordFormIsShown && props.signupQty===0 &&
					<button className={classes.btn}	onClick={setPassword}>
						Save my information for next time.
					</button>
				}
				{passwordFormIsShown && 				
					<div className={classes.svgWrapper}>
						<p>Your email address will be your userid. 
							The password you chose must be a "good" password.</p>
						<label htmlFor="password">Password:</label>
						<input 
							className={classes.passwordBox} 
							id="password" 
							type="password" 
							ref={inputPassword} 
							onChange={checkPasswordStrength}
						/>
						<div className={pwStrengthClass} ref={feedback}> </div>
						<label htmlFor="confirmPassword">Password:</label>
						<button className={classes.svg} onClick={showPassword}>
							<svg 
								viewBox="0 0 24 24" 
								fill="none" 
								stroke="currentColor" 
								strokeWidth="2" 
								strokeLinecap="round" 
								strokeLinejoin="round" 
								xmlns="http://www.w3.org/2000/svg" 
								aria-hidden="true"
							>
								<path 
									d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z">
								</path>
								<circle cx="12" cy="12" r="3"></circle>
							</svg>
						</button>
						<input 
							id="confirmPassword" 
							className={classes.passwordBox} 
							type="password" 
							ref={inputPasswordConfirmation} 
							onChange={checkPasswordStrength}
						/>
					</div>
				}
				<div id='msgDiv' ref={message}></div>
				<div className={classes.btnDiv}>
					<button className={classes.btn} onClick={props.onDone}>Cancel</button>
					<button className={submitClass} type="submit">Submit</button>
				</div>
			</form>
		</div>
	)
}

export default SignupForm;